import type { Schemas } from '@seoai/api-types';
import { useSession } from './session';

/**
 * İzin anahtarı — ELLE YAZILMAZ, üretilen şemadan türer (SEOAI-47).
 *
 * Backend'deki `Permission` enum'u OpenAPI şemasına rol izinleri üzerinden
 * bir string union olarak çıkıyor; panel anahtarlarını oradan alır. Sonuç:
 * `'project.veiw'` gibi bir yazım hatası DERLENMEZ. Elle liste tutmak, sessizce
 * gizlenen bir menü öğesi demekti — kimsenin fark etmeyeceği türden bir hata.
 */
export type Permission = Schemas['RoleDTO']['permissions'][number]['permission'];

/**
 * İzin kontrolü. Sunucu tarafı kontrolün YERİNE GEÇMEZ (§7 savunma derinliği):
 * URL elle yazılsa bile backend 403 döner. Buradaki kontrol yalnızca kullanıcıya
 * yapamayacağı şeyi göstermemek içindir.
 */
export function useCan(): (permission: Permission) => boolean {
  const permissions = useSession((state) => state.permissions);

  return (permission) => permissions.includes(permission);
}

/** Herhangi biri yeterli — bir menü öğesi birden çok uca açılabilir. */
export function useCanAny(): (permissions: readonly Permission[]) => boolean {
  const granted = useSession((state) => state.permissions);

  return (permissions) => permissions.some((permission) => granted.includes(permission));
}
